import type {CustomDealInProgress} from '../../../types';

import {Chip} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';

import CustomDealInfoRow from '../../../components/common/CustomDealInfoRow/CustomDealInfoRow';
import {CUSTOM_DEAL_STATUS_LABELS} from '../../../constants';
import {formatDealDateWithWeekday} from '../../../utils';

type DealDetailInfoProps = {
  deal: CustomDealInProgress;
};

const DealDetailInfo: React.FC<DealDetailInfoProps> = ({deal}) => {
  const chipProps = getStatusChipProps(deal.state);

  return (
    <section className="flex flex-col bg-white px-4">
      <CustomDealInfoRow
        title="وضعیت"
        value={
          <Chip
            label={CUSTOM_DEAL_STATUS_LABELS[deal.state] ?? deal.state ?? 'نامشخص'}
            variant={chipProps.variant}
            color={chipProps.color}
            size="sm"
            interactive={false}
          />
        }
      />
      <CustomDealInfoRow title="تاریخ شروع" value={formatDealDateWithWeekday(deal.start_date)} />
      <CustomDealInfoRow
        title="تاریخ پایان"
        value={formatDealDateWithWeekday(deal.end_date)}
        hasBorder={false}
      />
    </section>
  );
};

export default DealDetailInfo;
